module.exports = __webpack_public_path__ + "img/far-inbox.44c58d07.svg";